import React from 'react';
import iconwater from '@assets/images/icons/water-ico.svg';
import iconenergy from '@assets/images/icons/energy-ico.svg';
import iconco2 from '@assets/images/icons/co2-ico.svg';
import {IGaugeChartData} from '@src/types';
import {GradeColor} from '@constants/grade';
import {formatPercent} from '@components/module-components/consumtionGaugeChart/helpers';
import {useSelector} from 'react-redux';
import {translate} from '@src/helpers';
import {Translations} from '@constants/translate';
import '@components/module-components/consumtionGaugeChart/gauge-chart.scss';
import EcoScoreGauge from "@components/module-components/consumtionGaugeChart/EcoScoreGauge";

interface IPros {
  gaugeData: IGaugeChartData,
  className?: string
}

const ConsumptiongaugeChart = ({ gaugeData, className = ''}: IPros) => {
  const langData = useSelector((state: any) => state.currentLanguage) as any;

  // useEffect(() => {
  //   const gauge1 = document.getElementById("cirlce1");
  //   const gauge2 = document.getElementById("cirlce2");
  //   const gauge3 = document.getElementById("cirlce3");
  //
  //   if(gauge1) {
  //     const $selectGauge = new Gauge(gauge1);
  //     drawCirleChart($selectGauge, formatPercent(100 - gaugeData.carbon.reduce_increase));
  //   }
  //
  //   if(gauge2) {
  //     const $selectGauge = new Gauge(gauge2);
  //     drawCirleChart($selectGauge, formatPercent(100 - gaugeData.energy.reduce_increase));
  //   }
  //
  //   if(gauge3) {
  //     const $selectGauge = new Gauge(gauge3);
  //     drawCirleChart($selectGauge, formatPercent(100 - gaugeData.water.reduce_increase));
  //   }
  // }, [gaugeData]);

  return (
    <div className={`gauges${className ? ` ${className}` : ''}`}>
      <div className="row text-center">
        <div className="col col-4 co2">
          <h3>{translate(langData.localize, Translations["FIP.BRAND.ORDER.CO2_EMISSION"])}</h3>

          <div className="reduced mx-auto mb-3">
            <div className="reduced-img">
              <img src={iconco2} alt="message"/>
            </div>
            { gaugeData.carbon &&
              <span className="reduced-text">{gaugeData.carbon.reduce_increase >= 0 ? translate(langData.localize, Translations["FIP.COMMON.PRODUCED"]) : translate(langData.localize, Translations["FIP.COMMON.REDUCED"])} <span className="reduced-percent">{Math.abs(gaugeData.carbon.reduce_increase
              )}%</span></span>
            }
          </div>

          <h1>{ gaugeData.carbon && gaugeData.carbon.recorded }</h1>

          <div className="circle-chart">
            <EcoScoreGauge value={formatPercent(100 - gaugeData.carbon.reduce_increase)}/>
            <p className="gauges-type">{gaugeData.carbon.grade && <span style={{color: GradeColor[gaugeData.carbon.grade]}}>{gaugeData.carbon.grade }</span> }</p>
          </div>
        </div>
        <div className="col col-4 energy">
          <h3>{translate(langData.localize, Translations["FIP.BRAND.ORDER.ENERGY_USED"])}</h3>

          <div className="reduced mx-auto mb-3">
            <div className="reduced-img">
              <img src={iconenergy} alt="message"/>
            </div>
            { gaugeData.energy &&
              <span className="reduced-text">{gaugeData.energy.reduce_increase >= 0 ? translate(langData.localize, Translations["FIP.COMMON.WASTED"]) : translate(langData.localize, Translations["FIP.COMMON.SAVED"])} <span className="reduced-percent">{Math.abs(gaugeData.energy.reduce_increase)}%</span></span>
            }
          </div>

          <h1>{ gaugeData.energy && gaugeData.energy.recorded }</h1>
          <div className="circle-chart">
            <canvas width={98} height={70} id="cirlce2" data-current-value = "2000"></canvas>
            <EcoScoreGauge value={formatPercent(100 - gaugeData.energy.reduce_increase)}/>
            <p className="gauges-type">{gaugeData.energy.grade && <span style={{color: GradeColor[gaugeData.energy.grade]}}>{gaugeData.energy.grade }</span> }</p>
          </div>
        </div>
        <div className="col col-4 water">
          <h3>{translate(langData.localize, Translations["FIP.BRAND.ORDER.WATER_USED"])}</h3>

          <div className="reduced mx-auto mb-3">
            <div className="reduced-img">
              <img src={iconwater} alt="message"/>
            </div>
            { gaugeData.water &&
              <span className="reduced-text">{gaugeData.water.reduce_increase >= 0 ? translate(langData.localize, Translations["FIP.COMMON.WASTED"]) : translate(langData.localize, Translations["FIP.COMMON.SAVED"])} <span className="reduced-percent">{Math.abs(gaugeData.water.reduce_increase)}%</span></span>
            }
          </div>

          <h1>{ gaugeData.water && gaugeData.water.recorded }</h1>
          <div className="circle-chart">
            <EcoScoreGauge value={formatPercent(100 - gaugeData.water.reduce_increase)}/>
            <p className="gauges-type">{gaugeData.water.grade && <span style={{color: GradeColor[gaugeData.water.grade]}}>{gaugeData.water.grade }</span> }</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConsumptiongaugeChart;
